import React from "react";
import { Helmet } from "react-helmet";

import { useLocation, useSearchParams } from "react-router-dom";

import { FormContext } from "../Store/form-context";
import useRdapFetch from "../hooks/useRdapFetch";

import HeroWrapper from "../components/HeroWrapper/HeroWrapper";
import TabWrapper from "../components/TabWrapper/TabWrapper";
import SearchBox from "../components/SearchBox/SearchBox";
import ResultBox from "../components/ResultBox/ResultBox";

const RDAPLookup = () => {
	const location = useLocation();
	const [, setSearchParams] = useSearchParams();
	const { state, dispatch } = React.useContext(FormContext);
	const inputRef = React.createRef();
	const { rdapData } = useRdapFetch(
		state.rdap.isValid,
		state.rdap.inputValue.toLowerCase(),
	);

	React.useEffect(() => {
		const urlPath = location.pathname.replace("/", "");

		dispatch({ type: "CHANGE_TAB_TYPE", payload: { tabType: urlPath } });
	}, [location.pathname, dispatch]);

	React.useEffect(() => {
		const domainNameParam = new URLSearchParams(location.search).get("domain");

		if (domainNameParam) {
			dispatch({
				type: "ADD_RDAP",
				payload: { inputValue: domainNameParam.toLowerCase() },
			});
			dispatch({
				type: "ADD_DNS",
				payload: { inputValue: domainNameParam.toLowerCase() },
			});
		}
	}, [location.search, dispatch]);

	React.useEffect(() => {
		if (rdapData.data) setSearchParams({ domain: state.rdap.inputValue });
	}, [rdapData, setSearchParams, state.rdap.inputValue]);

	const inputChangeHandler = (e) => {
		dispatch({ type: "ADD_RDAP", payload: { inputValue: e.target.value } });
		dispatch({ type: "ADD_DNS", payload: { inputValue: e.target.value } });
	};

	return (
		<>
			<Helmet>
				<title>Domaintools - RDAP</title>
				<meta
					name="description"
					content="Look up domain registration data via RDAP (with WHOIS fallback)"
				/>
				<link rel="canonical" href="https://domaintools.nu/rdap" />
			</Helmet>
			<HeroWrapper text="RDAP" />
			<TabWrapper />

			<div className="search-container">
				<div className="search-box">
					<SearchBox
						inputName="rdap"
						value={state.rdap.inputValue}
						inputChangeHandler={inputChangeHandler}
						placeholderValue="example.com"
						inputRef={inputRef}
						isLoading={rdapData.loading}
						isValid={state.rdap.isValid}
					/>
				</div>
			</div>

			<ResultBox
				tabType={state.tabType}
				data={rdapData.data}
				error={rdapData.error}
			/>
		</>
	);
};

export default RDAPLookup;
